import { render, staticRenderFns } from "./ClientAdvanceTab.vue?vue&type=template&id=2a1c3a26&scoped=true"
import script from "./ClientAdvanceTab.vue?vue&type=script&lang=ts"
export * from "./ClientAdvanceTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1c3a26",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a1c3a26')) {
      api.createRecord('2a1c3a26', component.options)
    } else {
      api.reload('2a1c3a26', component.options)
    }
    module.hot.accept("./ClientAdvanceTab.vue?vue&type=template&id=2a1c3a26&scoped=true", function () {
      api.rerender('2a1c3a26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/components/ClientAdvanceTab.vue"
export default component.exports